/* eslint-disable react-hooks/exhaustive-deps */
import { DateTimePicker } from "@mui/lab";
import {
  Autocomplete,
  Badge,
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Paper,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Category, FilterList as FilterListIcon } from "@mui/icons-material";
import axios from "../../CustomAxios";
import { debounce } from "lodash";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function Filter({
  chalan,
  setChalan,
  setFilter,
  setStatus,
  setSelectedCompany,
  status,
  selectedCompany,
  received_date_from,
  setReceivedDateFrom,
  received_date_to,
  setReceivedDateTo,
  apCompanies,
  apCompany,
  setApCompany,
  notToBill,
  setNotToBill,
  productionRejection,
  setProductionRejection,
  referJob,
  setReferJob,
  user,
  paymentCompleted,
  setPaymentCompleted,
  plate,
  setPlate,
  setSortByDeliveryDate,
  sortByDeliveryDate,
  includeDeleted,
  setIncludeDeleted,
  machineList,
  setApMachine,
  apMachine,
  category,
  setCategory,
  categoryList,
  docketBy,
  setDocketBy
}) {
  const [open, setOpen] = React.useState(false);
  const [count, setCount] = useState(0);
  const [jobs, setJobs] = useState([]);
  const [plates, setPlates] = useState([]);
  const [customerCompanies, setCustomerCompanies] = useState([]);
  const [apCompaniesList, setApCompaniesList] = useState([]);
  const [searchCustomerCompany, setSearchCustomerCompany] = useState("");
  const [searchApCompany, setSearchApCompany] = useState("");
  const [apUserList, setApUserList] = useState([]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setFilter(true);
  };

  const resetFilters = () => {
    setStatus("");
    setSelectedCompany("");
    setChalan(null);
    setReceivedDateFrom("");
    setReceivedDateTo("");
    setApCompany("");
    setNotToBill(null);
    setProductionRejection(null);
    setReferJob("");
    setPaymentCompleted("");
    setPlate("");
    setIncludeDeleted(false);
    setApMachine("");
    setCategory("");
    setDocketBy("");
  };

  useEffect(() => {
    let totalCount = 0;
    if (
      chalan === "true" ||
      chalan === true ||
      chalan === "false" ||
      chalan === false
    ) {
      totalCount += 1;
    }
    if (
      paymentCompleted === "true" ||
      paymentCompleted === true ||
      paymentCompleted === "false" ||
      paymentCompleted === false
    ) {
      totalCount += 1;
    }
    if (status) {
      totalCount += 1;
    }
    if (selectedCompany) {
      totalCount += 1;
    }
    if (received_date_from) {
      totalCount += 1;
    }
    if (received_date_to) {
      totalCount += 1;
    }
    if (apCompany) {
      totalCount += 1;
    }
    if (notToBill !== null && notToBill !== "null" && notToBill !== "") {
      totalCount += 1;
    }
    if (
      productionRejection !== null &&
      productionRejection !== "null" &&
      productionRejection !== ""
    ) {
      totalCount += 1;
    }
    if (plate) {
      totalCount++;
    }
    if (referJob) {
      totalCount += 1;
    }
    if (includeDeleted) {
      totalCount += 1;
    }
    if (apMachine) {
      totalCount += 1;
    }
    if (category) {
      totalCount += 1;
    }
    if (docketBy) {
      totalCount += 1;
    }
    setCount(totalCount);
  }, [
    chalan,
    status,
    selectedCompany,
    received_date_from,
    received_date_to,
    apCompany,
    notToBill,
    productionRejection,
    referJob,
    plate,
    paymentCompleted,
    includeDeleted,
    apMachine,
  ]);

  const getJobs = async () => {
    try {
      const userData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + userData.access_token,
        },
      };
      if (userData?.type === "ap_user" || userData?.type === "super_admin") {
        const { data } = await axios.get(
          `/api/v1/${userData?.type}/jobs?is_table=true`,
          config
        );
        if (data.success) {
          setJobs(data.data);
        }
      } else {
        if (
          user.user?.customer_company._id !== undefined &&
          user.user !== null
        ) {
          const { data } = await axios.get(
            `/api/v1/${userData?.type}/${user.user?.customer_company._id}/jobs?is_table=true`,
            config
          );
          if (data.success) {
            setJobs(data.data.data);
          }
        }
      }
    } catch (e) {
      console.log("error in job", e);
    }
  };

  const getPlates = async () => {
    try {
      const userData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + userData.access_token,
        },
      };
      if (userData?.type === "ap_user" || userData?.type === "super_admin") {
        const { data } = await axios.get(
          `/api/v1/${userData?.type}/plate_inventory?page=0&limit=500`,
          config
        );
        if (data.success) {
          setPlates(data.data.data);
        }
      }
    } catch (e) {
      console.log("error in plates", e);
    }
  };

  const fetchApUsers = async () => {
    try {
      const userData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + userData.access_token,
        },
      };
      const { data } = await axios.get(
        `/api/v1/${userData?.type}/ap_user`,
        config
      );
      if (data.success) {
        setApUserList(data.data.data);
      }
    } catch (e) {
      console.log("error in fetching ap users", e);
    }
  };

  const fetchCompanies = async (search, type) => {
    try {
      const userData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + userData.access_token,
        },
      };
      const url = type === "customer"
        ? `/api/v1/${userData?.type}/customer_company?limit=5&search_keyword=${search}`
        : `/api/v1/${userData?.type}/ap_company?limit=5&search_keyword=${search}`;
      const { data } = await axios.get(url, config);
      if (data.success) {
        if (type === "customer") {
          setCustomerCompanies(data.data.data);
        } else {
          setApCompaniesList(data.data.data);
        }
      }
    } catch (e) {
      console.log("error in fetching companies", e);
    }
  };

  const debouncedFetchCompanies = debounce((search, type) => {
    fetchCompanies(search, type);
  }, 300);

  useEffect(() => {
    getJobs();
    getPlates();
    fetchCompanies("", "customer");
    fetchCompanies("", "ap");
    fetchApUsers();
  }, []);

  useEffect(() => {
    if (searchCustomerCompany) {
      debouncedFetchCompanies(searchCustomerCompany, "customer");
    } else {
      fetchCompanies("", "customer");
    }
  }, [searchCustomerCompany]);

  useEffect(() => {
    if (searchApCompany) {
      debouncedFetchCompanies(searchApCompany, "ap");
    } else {
      fetchCompanies("", "ap");
    }
  }, [searchApCompany]);

  const [searchText, setSearchText] = useState("");
  const authData = JSON.parse(localStorage.getItem("AuthData"));

  return (
    <Paper>
      <Tooltip title="Filters">
        <Badge badgeContent={count} color="error">
          <IconButton onClick={handleOpen} aria-label="Filters" size="small">
            <FilterListIcon />
          </IconButton>
        </Badge>
      </Tooltip>
      <Modal open={open} onClose={handleClose}>
        <Card sx={style} style={{ width: "30vw" }}>
          <CardContent>
            <Paper>
              <Grid container spacing={5}>
                {authData?.type !== "customer_user" ? (
                  <Grid item xs={12} md={6} lg={6}>
                    <Autocomplete
                      options={apCompaniesList}
                      getOptionLabel={(option) => option.name}
                      filterOptions={(options, { inputValue }) => {
                        if (!inputValue) return options;
                        const searchTerm = inputValue.toLowerCase();
                        return options.filter(option =>
                          option.name.toLowerCase().includes(searchTerm)
                        );
                      }}
                      value={apCompaniesList.find(c => c._id === apCompany) || null}
                      onChange={(e, newValue) => setApCompany(newValue?._id || "")}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select AP Company"
                          placeholder="Search AP companies..."
                          variant="outlined"
                          onChange={(e) => setSearchApCompany(e.target.value)}
                        />
                      )}
                      fullWidth
                      sx={{
                        "& .MuiAutocomplete-listbox": { maxHeight: 200 },
                      }}
                    />
                  </Grid>
                ) : null}
                {authData?.type !== "customer_user" && (
                  <Grid item xs={12} md={6} lg={6}>
                    <Autocomplete
                      id="combo-box-demo"
                      options={machineList}
                      filterOptions={(options, { inputValue }) => {
                        if (!inputValue) return options.slice(0, 5); // Show only 5 options initially
                        const searchTerm = inputValue.toLowerCase();
                        return options.filter(option =>
                          option.name.toLowerCase().includes(searchTerm) ||
                          option.serial_no.toLowerCase().includes(searchTerm)
                        );
                      }}
                      value={machineList.find(
                        (item) => item._id === apMachine
                      )}
                      onChange={(event, newValue) => {
                        setApMachine(newValue?._id || "");
                      }}
                      getOptionLabel={(option) => `${option?.name}-${option.serial_no}` || ""}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="AP Machine"
                          placeholder="Select AP machine"
                          variant="outlined"
                        />
                      )}
                      fullWidth
                    />
                  </Grid>
                )}
                {authData?.type !== "customer_user" && (
                  <Grid item xs={12} md={6} lg={6}>
                    <Autocomplete
                      options={customerCompanies}
                      getOptionLabel={(option) => option.name}
                      filterOptions={(options, { inputValue }) => {
                        if (!inputValue) return options;
                        const searchTerm = inputValue.toLowerCase();
                        return options.filter((option) =>
                          option.name.toLowerCase().includes(searchTerm)
                        );
                      }}
                      value={customerCompanies.find((c) => c._id === selectedCompany) || null}
                      onChange={(e, newValue) => setSelectedCompany(newValue?._id || "")}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Customer Company"
                          placeholder="Search customer companies..."
                          variant="outlined"
                          onChange={(e) => setSearchCustomerCompany(e.target.value)}
                        />
                      )}
                      fullWidth
                      sx={{
                        "& .MuiAutocomplete-listbox": { maxHeight: 200 },
                      }}
                    />
                  </Grid>
                )}
                {authData?.type !== "customer_user" ? (
                  <Grid item xs={12} md={6} lg={6}>
                    <Autocomplete
                      options={plates}
                      getOptionLabel={(option) =>
                        `${option.height}X${option.width}X${option.thickness} || ${option.brand?.name} || ${option.technology?.name}`
                      }
                      filterOptions={(options, { inputValue }) => {
                        if (!inputValue) return options;
                        const searchTerm = inputValue.toLowerCase();
                        return options.filter(option =>
                          option.brand?.name.toLowerCase().includes(searchTerm) ||
                          option.technology?.name.toLowerCase().includes(searchTerm)
                        );
                      }}
                      value={plates.find(p => p._id === plate) || null}
                      onChange={(e, newValue) => setPlate(newValue?._id || "")}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Plate"
                          placeholder="Search plates..."
                          variant="outlined"
                        />
                      )}
                      fullWidth
                      sx={{
                        "& .MuiAutocomplete-listbox": { maxHeight: 200 },
                      }}
                    />
                  </Grid>
                ) : null}
                <Grid item xs={12} md={6} lg={6}>
                  <FormControl fullWidth>
                    <InputLabel id="label">Select Status</InputLabel>
                    <Select
                      fullWidth
                      labelId="label"
                      id="label"
                      label="Select Status"
                      onChange={(e) => setStatus(e.target.value)}
                      value={status}
                    >
                      <MenuItem value="" disabled>
                        Select Status
                      </MenuItem>
                      <MenuItem value="requested">Requested</MenuItem>
                      <MenuItem value="new">new</MenuItem>
                      <MenuItem value="studio">Studio</MenuItem>
                      <MenuItem value="ctp_impose">CTP Impose</MenuItem>
                      <MenuItem value="ctp">CTP</MenuItem>
                      <MenuItem value="delivery">Delivery</MenuItem>
                      <MenuItem value="customer_accept">
                        Customer Accept
                      </MenuItem>
                      <MenuItem value="billing">Billing</MenuItem>
                      <MenuItem value="payment">Payment</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <Autocomplete
                    id="combo-box-demo"
                    options={categoryList}
                    value={category}
                    onChange={(event, newValue) => {
                      setCategory(newValue || "");
                    }}
                    getOptionLabel={(option) => `${option}` || ""}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Category"
                        placeholder="Select Category"
                        variant="outlined"
                      />
                    )}
                    fullWidth
                  />
                </Grid>
                {jobs !== undefined && jobs.length !== 0 && authData?.type === "super_admin" && (
                  <>
                    <Grid item xs={12} md={6} lg={6}>
                      <FormControl fullWidth>
                        <Autocomplete
                          id="combo-box-demo"
                          options={jobs}
                          filterOptions={(options, { inputValue }) => {
                            const filtered = options.filter(option =>
                              option?.job_id?.toLowerCase().includes(inputValue.toLowerCase()) ||
                              option?.name?.toLowerCase().includes(inputValue.toLowerCase())
                            );
                            return inputValue ? filtered : filtered.slice(0, 4);
                          }}
                          value={
                            jobs.length !== 0 &&
                            referJob !== null &&
                            jobs.find((item) => item._id === referJob)
                          }
                          onChange={(e, newValue) => {
                            setReferJob(newValue?._id || "");
                          }}
                          getOptionLabel={(option) =>
                            option?.job_id + " - " + option?.name
                          }
                          renderInput={(params) => (
                            <TextField {...params} label="Referred Job" />
                          )}
                          fullWidth
                          sx={{
                            '& .MuiAutocomplete-listbox': {
                              maxHeight: '100px !important',
                              overflow: 'auto',
                            },
                          }}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6} lg={6}>
                      <FormControl fullWidth>
                        <Autocomplete
                          id="docket-by-filter"
                          options={apUserList}
                          filterOptions={(options, { inputValue }) => {
                            if (!inputValue) return options.slice(0, 5); // Show only 5 options initially
                            const searchTerm = inputValue.toLowerCase();
                            return options.filter(option =>
                              option.name.toLowerCase().includes(searchTerm)
                            );
                          }}
                          getOptionLabel={(option) => `${option.name}`}
                          value={apUserList.find(user => user._id === docketBy) || null}
                          onChange={(e, newValue) => setDocketBy(newValue?._id || "")}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Docket By"
                              placeholder="Select AP User"
                              variant="outlined"
                            />
                          )}
                          fullWidth
                        />
                      </FormControl>
                    </Grid>
                  </>
                )}
                {jobs !== undefined && jobs.length !== 0 && authData?.type !== "super_admin" && (
                  <Grid item xs={12} md={12} lg={12}>
                    <FormControl fullWidth>
                      <Autocomplete
                        id="combo-box-demo"
                        options={jobs}
                        filterOptions={(options, { inputValue }) => {
                          const filtered = options.filter(option =>
                            option?.job_id?.toLowerCase().includes(inputValue.toLowerCase()) ||
                            option?.name?.toLowerCase().includes(inputValue.toLowerCase())
                          );
                          return inputValue ? filtered : filtered.slice(0, 4);
                        }}
                        value={
                          jobs.length !== 0 &&
                          referJob !== null &&
                          jobs.find((item) => item._id === referJob)
                        }
                        onChange={(e, newValue) => {
                          setReferJob(newValue?._id || "");
                        }}
                        getOptionLabel={(option) =>
                          option?.job_id + " - " + option?.name
                        }
                        renderInput={(params) => (
                          <TextField {...params} label="Referred Job" />
                        )}
                        fullWidth
                        sx={{
                          '& .MuiAutocomplete-listbox': {
                            maxHeight: '100px !important',
                            overflow: 'auto',
                          },
                        }}
                      />
                    </FormControl>
                  </Grid>
                )}
                <Grid item xs={6} md={6} lg={6}>
                  <FormControl fullWidth>
                    <DateTimePicker
                      name="recieved_date_from"
                      format="YYYY-MM-DD HH:mm:ss"
                      renderInput={(props) => <TextField {...props} />}
                      label="Recieved Date From"
                      value={received_date_from || null}
                      onChange={(newValue) => {
                        if (newValue) {
                          // Convert IST to UTC
                          const utcDate = new Date(newValue.getTime() - (newValue.getTimezoneOffset() * 60000));
                          const utcString = utcDate.toISOString().slice(0, 19).replace('T', ' ');
                          setReceivedDateFrom(utcString);
                        } else {
                          setReceivedDateFrom("");
                        }
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={6} md={6} lg={6}>
                  <FormControl fullWidth>
                    <DateTimePicker
                      name="recieved_date_to"
                      format="YYYY-MM-DD HH:mm:ss"
                      renderInput={(props) => <TextField {...props} />}
                      label="Recieved Date To"
                      value={received_date_to || null}
                      onChange={(newValue) => {
                        if (newValue) {
                          // Convert IST to UTC
                          const utcDate = new Date(newValue.getTime() - (newValue.getTimezoneOffset() * 60000));
                          const utcString = utcDate.toISOString().slice(0, 19).replace('T', ' ');
                          setReceivedDateTo(utcString);
                        } else {
                          setReceivedDateTo("");
                        }
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6} lg={6} >
                  <Typography variant="h6">Chalan Created</Typography>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={
                          chalan === true || chalan === "true" ? true : false
                        }
                        onChange={(e) => setChalan(e.target.checked)}
                      />
                    }
                    label="Yes"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={
                          chalan === false || chalan === "false" ? true : false
                        }
                        onChange={(e) => setChalan(!e.target.checked)}
                      />
                    }
                    label="No"
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <Typography variant="h6">Payment Completed</Typography>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={
                          paymentCompleted === true ||
                            paymentCompleted === "true"
                            ? true
                            : false
                        }
                        onChange={(e) => setPaymentCompleted(e.target.checked)}
                      />
                    }
                    label="Yes"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={
                          paymentCompleted === false ||
                            paymentCompleted === "false"
                            ? true
                            : false
                        }
                        onChange={(e) => setPaymentCompleted(!e.target.checked)}
                      />
                    }
                    label="No"
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={notToBill === "YES" ? true : false}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setNotToBill("YES");
                          } else {
                            setNotToBill("");
                          }
                        }}
                      />
                    }
                    label="NOT TO BILL"
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={productionRejection === "YES" ? true : false}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setProductionRejection("YES");
                          } else {
                            setProductionRejection("");
                          }
                        }}
                      />
                    }
                    label="Production Rejection"
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={includeDeleted}
                        onChange={(e) => setIncludeDeleted(e.target.checked)}
                      />
                    }
                    label="Show Deleted Jobs"
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={(sortByDeliveryDate === "true" || sortByDeliveryDate === true) ? true : false}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSortByDeliveryDate(true);
                          } else {
                            setSortByDeliveryDate(false);
                          }
                        }}
                      />
                    }
                    label="Sort By Delivery Date"
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <Button onClick={resetFilters} color="error">
                    Reset All Filter
                  </Button>
                </Grid>
                <Grid
                  container
                  justifyContent={"flex-end"}
                  item
                  xs={12}
                  md={6}
                  lg={6}
                >
                  <Button onClick={handleClose} color="success">
                    OK
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </CardContent>
        </Card>
      </Modal>
    </Paper>
  );
}

export default Filter;
